import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// components
import { FloatingActions } from 'components/FormElements'
// context
import { ActionContext, ActionCreationContext } from 'context'
import { LinkingModeContext } from 'containers/Plan/Edit/layers/API/Linking'
// constants
import { Forms, OBJECT_ENTITY_NAMES } from 'constants/index'
// hooks
import { useFieldAccess, useFormDirtyCount, useReviewFieldIds } from 'hooks'
// types
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// views
import { Collapse, Form } from 'components/Modals/PlanItems/styles'
// utils
import get from 'lodash/get'
import { generateFields } from 'utils/fields'

interface Props {
  onCancelClick: () => void
}

const DetailsForm: React.FC<InjectedFormProps<any, Props> & Props> = ({
  form,
  reset,
  valid,
  handleSubmit,
  onCancelClick
}) => {
  const [isCollapsed, setExpanded] = React.useState(false)

  const { plan, entity, handleDetailsSubmit } = React.useContext<any>(ActionContext)
  const { fields, isCreateForm } = React.useContext<any>(ActionCreationContext)
  const { isLinkingMode } = React.useContext(LinkingModeContext)

  const canViewRestricted = useFieldAccess(entity)
  const reviewFieldIds = useReviewFieldIds(OBJECT_ENTITY_NAMES.ACTION)

  const { dirtyFieldsCount } = useFormDirtyCount(form)

  const { actionModifyAction, actionSetUserActionSecurity } = get(entity, 'currentPermissions', {})

  React.useEffect(() => {
    if (isLinkingMode) {
      setExpanded(true)
    }
  }, [isLinkingMode])

  return (
    <>
      <Collapse isCollapsed={isCollapsed} handleClick={() => setExpanded(!isCollapsed)}>
        About this action
      </Collapse>
      {!isCollapsed && (
        <Form onSubmit={handleSubmit}>
          {(fields || entity.fields)
            .filter((field) => field.name !== 'completionPercentage' && !reviewFieldIds.includes(field.id))
            .map((field) =>
              generateFields({
                field,
                form,
                canViewRestricted,
                canModify: form === Forms.ACTION_CREATE_FORM || (!plan.locked && actionModifyAction),
                canSetPermissions: form === Forms.ACTION_CREATE_FORM || actionSetUserActionSecurity
              })
            )}
          <FloatingActions
            form={form}
            valid={valid}
            isCreateForm={isCreateForm}
            dirtyCount={dirtyFieldsCount}
            handleConfirm={handleDetailsSubmit}
            onCancel={isCreateForm ? onCancelClick : reset}
          />
        </Form>
      )}
    </>
  )
}

export default reduxForm<any, Props>({
  destroyOnUnmount: false,
  enableReinitialize: true
})(DetailsForm)
